/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MonitAccountResolutionRequest
 */
export interface MonitAccountResolutionRequest {
    /**
     * 
     * @type {string}
     * @memberof MonitAccountResolutionRequest
     */
    asset?: string;
    /**
     * 
     * @type {string}
     * @memberof MonitAccountResolutionRequest
     */
    port?: string;
    /**
     * 
     * @type {string}
     * @memberof MonitAccountResolutionRequest
     */
    domain?: string;
    /**
     * 
     * @type {string}
     * @memberof MonitAccountResolutionRequest
     */
    datapoint?: string;
    /**
     * 
     * @type {string}
     * @memberof MonitAccountResolutionRequest
     */
    reason?: string;
    /**
     * 
     * @type {string}
     * @memberof MonitAccountResolutionRequest
     */
    reviewed_by?: string;
}

/**
 * Check if a given object implements the MonitAccountResolutionRequest interface.
 */
export function instanceOfMonitAccountResolutionRequest(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function MonitAccountResolutionRequestFromJSON(json: any): MonitAccountResolutionRequest {
    return MonitAccountResolutionRequestFromJSONTyped(json, false);
}

export function MonitAccountResolutionRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): MonitAccountResolutionRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'asset': !exists(json, 'asset') ? undefined : json['asset'],
        'port': !exists(json, 'port') ? undefined : json['port'],
        'domain': !exists(json, 'domain') ? undefined : json['domain'],
        'datapoint': !exists(json, 'datapoint') ? undefined : json['datapoint'],
        'reason': !exists(json, 'reason') ? undefined : json['reason'],
        'reviewed_by': !exists(json, 'reviewed_by') ? undefined : json['reviewed_by'],
    };
}

export function MonitAccountResolutionRequestToJSON(value?: MonitAccountResolutionRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'asset': value.asset,
        'port': value.port,
        'domain': value.domain,
        'datapoint': value.datapoint,
        'reason': value.reason,
        'reviewed_by': value.reviewed_by,
    };
}

